import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { SmartToyOutlined } from '@mui/icons-material';
import { Avatar } from '@mui/material';

import ProtectedData, { isProtectedData, UNKNOWN } from 'pages/item/v2/components/ProtectedData';
import RevisionSelect from 'pages/item/v2/components/RevisionSelect';
import parseDate from 'utils/parse-data';
import Utils from 'utils/Utils';

import useStyles from './styles';

interface Props {
    id: string;
    published: string;
    reporter: string | undefined;
    href: string | undefined;
    type: string;
    className?: string;
}

const Summary: React.FC<Props> = ({ id, href, reporter, type, published, className }) => {
    const { classes, cx } = useStyles();

    const source = useMemo(() => {
        switch (true) {
            case isProtectedData(reporter):
                return reporter;
            case !!reporter:
                return String(reporter)[0].toUpperCase() + String(reporter).slice(1);
            case isProtectedData(href):
                return UNKNOWN;
            case !!href:
                return new URL(String(href)).host;
            default:
                return null;
        }
    }, [href, reporter]);

    return (
        <div className={cx(classes.container, className)}>
            <div className={classes.text}>
                <ProtectedData data={type} rounded>
                    {({ isProtected }) => (
                        <Avatar
                            {...(isProtected
                                ? { children: <SmartToyOutlined color="action" /> }
                                : {
                                      component: Link,
                                      to: `/search?query=type:${type}`,
                                      src: Utils.getImage(type),
                                      alt: type
                                  })}
                            className={classes.avatar}
                        />
                    )}
                </ProtectedData>

                {source ? (
                    <ProtectedData data={source}>
                        <span className={classes.source}>{source}</span>
                    </ProtectedData>
                ) : null}
                <span className={classes.id}>{id}</span>
            </div>
            <ProtectedData data={published}>
                {({ isProtected }) => (
                    <RevisionSelect id={id} published={isProtected ? undefined : parseDate(published)} />
                )}
            </ProtectedData>
        </div>
    );
};

export default Summary;
